var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssaniaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 38,
    viewBox: "0 0 259 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 13H57V27H40V13Z",
    fill: "#CF1463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153 12H169.719V26H153V12Z",
    fill: "#CF1463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 16.5L216 21L220.5 30H206.5L211.5 16.5Z",
    fill: "#CF1463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22H46V18H57V22ZM57 10V14H41V26H57V30H37V10H57Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6562 30H59.6562V26H83.6562C84.2188 26 84.6875 25.8125 85.0625 25.4375C85.4583 25.0417 85.6562 24.5625 85.6562 24C85.6562 23.4375 85.4583 22.9688 85.0625 22.5938C84.6875 22.1979 84.2188 22 83.6562 22H75.6562C73.9896 22 72.5729 21.4167 71.4062 20.25C70.2396 19.0833 69.6562 17.6667 69.6562 16C69.6562 14.3333 70.2396 12.9167 71.4062 11.75C72.5729 10.5833 73.9896 10 75.6562 10H87.6562V14H75.6562C75.0938 14 74.6146 14.1979 74.2188 14.5938C73.8438 14.9688 73.6562 15.4375 73.6562 16C73.6562 16.5625 73.8438 17.0417 74.2188 17.4375C74.6146 17.8125 75.0938 18 75.6562 18H83.6562C85.3229 18 86.7396 18.5833 87.9062 19.75C89.0729 20.9167 89.6562 22.3333 89.6562 24C89.6562 25.6667 89.0729 27.0833 87.9062 28.25C86.7396 29.4167 85.3229 30 83.6562 30Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.656 22H93.6562V18H113.656V22Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.656 30H117.656V26H141.656C142.219 26 142.688 25.8125 143.062 25.4375C143.458 25.0417 143.656 24.5625 143.656 24C143.656 23.4375 143.458 22.9688 143.062 22.5938C142.688 22.1979 142.219 22 141.656 22H133.656C131.99 22 130.573 21.4167 129.406 20.25C128.24 19.0833 127.656 17.6667 127.656 16C127.656 14.3333 128.24 12.9167 129.406 11.75C130.573 10.5833 131.99 10 133.656 10H145.656V14H133.656C133.094 14 132.615 14.1979 132.219 14.5938C131.844 14.9688 131.656 15.4375 131.656 16C131.656 16.5625 131.844 17.0417 132.219 17.4375C132.615 17.8125 133.094 18 133.656 18H141.656C143.323 18 144.74 18.5833 145.906 19.75C147.073 20.9167 147.656 22.3333 147.656 24C147.656 25.6667 147.073 27.0833 145.906 28.25C144.74 29.4167 143.323 30 141.656 30Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.719 22H158.719V18H169.719V22ZM169.719 10V14H153.719V26H169.719V30H149.719V10H169.719Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 16V30H173.5V10H177.5L189.5 24V10H193.5V30H189.5L177.5 16Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.938 30H197.938V10H201.938V30Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.938 30L212.938 9L222.938 30H218.438L212.938 18.5L207.438 30H202.938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssaniaWhite);
export default __webpack_public_path__ + "static/media/essania_white.69fb84a08d9bf724d9e54624496a78d0.svg";
export { ForwardRef as ReactComponent };